import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this.closeOnEscape)
  }

  disconnect() {
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this.closeOnEscape)
  }

  closeOnEscape = (event) => {
    if (event.key === "Escape") this.close()
  }

  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) this.close()
  }

  close() {
    document.getElementById("modal")?.replaceChildren()
  }
}
